import store from '../components/store';

export class Permissions {
  private static permissions = [];
  private static managed = [];
  private static staticPermissions = null;

  private static generate() {
    const { user } = store.getState().AuthReducer;
    const permissions = !!user ? user.permissions : [];
    if (this.staticPermissions !== permissions) {
      this.staticPermissions = permissions;
      this.permissions = [];
      this.managed = [];
      permissions.forEach((perm) => {
        this.permissions.push(perm.name);
        if (perm.pivot.type === 'manage') {
          this.managed.push(perm.name);
        }
      });
    }
  }

  private static getBoolean(name: string, type: string = 'permissions'): boolean {
    this.generate();
    return this[type].indexOf(name) > -1;
  }

  static has(name: string): boolean {
    return this.getBoolean(name);
  }

  static hasOneOf(names: Array<string>): boolean {
    let has = false;
    names.forEach((name) => {
      if (this.getBoolean(name)) {
        has = true;
      }
    });
    return has;
  }

  static manage(name: string): boolean {
    return this.getBoolean(name, 'managed');
  }
}
